import React, { useState, useEffect } from 'react';
import { safeLocalStorage } from '../utils/storage';
import './CookieBanner.css';

const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consentimiento = safeLocalStorage.getItem('bunker_cookie_consent');
        if (!consentimiento) {
            // Mostrar después de un pequeño delay para efecto visual
            const timer = setTimeout(() => setVisible(true), 2000);
            return () => clearTimeout(timer);
        }
    }, []);

    const aceptarCookies = () => {
        safeLocalStorage.setItem('bunker_cookie_consent', 'accepted');
        if (typeof window.gtag === 'function') {
            window.gtag('consent', 'update', {
                ad_storage: 'granted',
                ad_user_data: 'granted',
                ad_personalization: 'granted',
                analytics_storage: 'granted'
            });
        }
        setVisible(false);
    };

    const rechazarCookies = () => {
        safeLocalStorage.setItem('bunker_cookie_consent', 'rejected');
        if (typeof window.gtag === 'function') {
            window.gtag('consent', 'update', {
                ad_storage: 'denied',
                ad_user_data: 'denied',
                ad_personalization: 'denied',
                analytics_storage: 'denied'
            });
        }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner-bunker">
            <div className="cookie-content">
                <div className="cookie-icon">🍪</div>
                <div className="cookie-text">
                    <span className="alert-text">PROTOCOLO DE RASTREO:</span> 
                    Este búnker utiliza cookies para analizar el tráfico táctico y personalizar la publicidad de AdSense. 
                    ¿Permite el uso de estas balizas de datos para mejorar la experiencia del agente?
                </div>
                <div className="cookie-buttons">
                    <button onClick={aceptarCookies} className="btn-cookie accept">AUTORIZAR</button>
                    <button onClick={rechazarCookies} className="btn-cookie reject">DENEGAR</button>
                    <a href="/cookies" className="cookie-link">MÁS INFO</a>
                </div>
            </div>
            <div className="scanner-line-cookie"></div>
        </div>
    );
};

export default CookieBanner;
